export default "__VITE_ASSET__BOe1h$6y__"